export const EqualHousingLenderIcon = ({ color = '#1A1A1A', ...props }) => (
  <svg
    width={'22px'}
    height={'16px'}
    viewBox={'0 0 22 16'}
    version={'1.1'}
    xmlns={'http://www.w3.org/2000/svg'}
    xmlnsXlink={'http://www.w3.org/1999/xlink'}
    {...props}
  >
    <title>icon_equalHousingLender</title>
    <g
      id={'Home'}
      stroke={'none'}
      strokeWidth={'1'}
      fill={'none'}
      fillRule={'evenodd'}
      opacity={'0.697800409'}
    >
      <g
        id={'scroll-1-copy-2'}
        transform={'translate(-239.000000, -10063.000000)'}
        fill={color}
      >
        <g
          id={'Group-25'}
          transform={'translate(0.000000, 8730.000000)'}
        >
          <g
            id={'EHL-copy-right'}
            transform={'translate(239.000000, 1332.000000)'}
          >
            <g
              id={'EHL'}
              transform={'translate(0.000000, 1.000000)'}
            >
              <path
                d={'M11.1255273,5.77418636e-05 L0,6.14494687 L0,8.35588283 L1.70859924,8.35588283 L1.70859924,15.9922443 L20.2646295,15.9922443 L20.2646295,8.35588283 L22,8.35588283 L22,6.19633713 L11.1255273,5.77418636e-05 Z M3.97344511,6.38919495 L11.1255273,2.31377422 L18.13245,6.38919495 L18.13245,14.0509628 L3.97344511,14.0509628 L3.97344511,6.38919495 Z M7.32401298,8.98007238 L14.7283396,8.98007238 L14.7283396,7.09018118 L7.32401298,7.09018118 L7.32401298,8.98007238 Z M7.32401298,12.1096814 L14.7283396,12.1096814 L14.7283396,10.2330708 L7.32401298,10.2330708 L7.32401298,12.1096814 Z'}
                id={'icon_equalHousingLender'}
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
